document.addEventListener("DOMContentLoaded", () => {
  const videoWrappers = document.querySelectorAll(".media-with-description__video");
  videoWrappers.forEach((videoWrapper) => {
    const video = videoWrapper.querySelector("video");
    const playBtn = videoWrapper.querySelector(".media-with-description__video-play-btn");
    const stopBtn = videoWrapper.querySelector(".media-with-description__video-stop-btn");
    const volumeSlider = videoWrapper.querySelector(".media-with-description__video-volume");

    playBtn.addEventListener("click", () => {
      video.play();
      playBtn.classList.remove("active");
      stopBtn.classList.add("active");
      volumeSlider.classList.add("show");
    });

    stopBtn.addEventListener("click", () => {
      video.pause();
      stopBtn.classList.remove("active");
      playBtn.classList.add("active");
      volumeSlider.classList.remove("show");
    });

    volumeSlider.addEventListener("input", (e) => {
      video.volume = e.target.value;
    });
  });
});
